// extracted by mini-css-extract-plugin
export var container = "_ad-0";
export var icon = "_ad-1";
export var text = "_ad-2";